import { useEffect, useRef } from "react";
import { init, use as registerECharts, type EChartsCoreOption } from "echarts/core";
import { LineChart, PieChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent, AriaComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";
registerECharts([LineChart, PieChart, GridComponent, TooltipComponent, LegendComponent, AriaComponent, CanvasRenderer]);
export function EChart({ option, label }: { option: EChartsCoreOption; label: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!ref.current) return;
    const chart = init(ref.current);
    chart.setOption({ ...option, animation: false, aria: { enabled: true, label: { description: label } } });
    const observer = new ResizeObserver(() => chart.resize());
    observer.observe(ref.current);
    return () => { observer.disconnect(); chart.dispose(); };
  }, [option, label]);
  return <div ref={ref} className="overview-echart" role="img" aria-label={label} />;
}
